import { useSelector } from "react-redux";
import { Navigate} from "react-router-dom";
const PrivateRoute = ({ children, roleRequired }) => {
  // roleRequired ==> 可适配用户权限
  const { isAuthenticated, user } = useSelector((state) => state.auth);
  if (!isAuthenticated) {
    return <Navigate to="/login" />;
  }

  if (roleRequired && user?.role && user?.role !== roleRequired) {
    return <Navigate to="/404" />;
  }

  return children;
};

export default PrivateRoute;
